import React, {useContext} from 'react'
import {
  Paper,
  Grid,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  Radio,
  Container,
} from '@material-ui/core/'
import '../../styles/BarcodeLanding.css'
import WizardImage from '../../assets/images/BG_Barcode_Wizard.png'
import LibraryImage from '../../assets/images/BG_My_Library.png'
import {Link} from 'react-router-dom'
import {Mutation} from 'react-apollo'
import {userUpdate} from '../../graphql/barcode/mutations/userSettingMutation'
import {useTranslation} from 'react-i18next'
import {BarcodeUrlSkipContext} from '../../context/BarcodeUrlSkip'
import useStyles from './BarcodeLanding.styles'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import BambooBanner from '../BambooBanner'

export default function BarcodeLanding() {
  const classes = useStyles()
  const {t} = useTranslation()
  const [selectedValue, setSelectedValue] = React.useState('')
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const {setUrlGoTo} = useContext(BarcodeUrlSkipContext)
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)

  function handleChange(update, event) {
    update({
      variables: {
        id: userSettings.id,
        setting: event.target.value,
      },
    })
    setSelectedValue(event.target.value)
  }

  function pageClick(event) {
    setUrlGoTo('')
    setBarcodeLabelRecord('')
    setBarcodeSheetRecord('')
  }

  return (
    <div>
      <BambooBanner bannerType={'barcodeBanner'} />
      <div className="welcome-text" style={{fontWeight: 'bold'}}>
        <p>{t('barcode.landing-page.simplest-way')}</p>
        <p>{t('barcode.landing-page.all-equipment')}</p>
      </div>
      <Container>
        <div>
          <Grid container spacing={8} justify="center">
            <Grid item xs={5}>
              <Paper>
                <Card>
                  <CardContent classes={{root: classes.cardAction}}>
                    <img
                      src={LibraryImage}
                      className={[classes.image, classes.libraryBG].join(' ')}
                      alt="Library Display"
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        color="primary"
                        style={{fontWeight: 'bold'}}
                      >
                        {t('barcode.landing-page.my-library')}
                      </Typography>
                      <Typography variant="body2" component="p" style={{fontWeight: 'bold'}}>
                        {t('barcode.landing-page.choose-existing')}
                      </Typography>
                    </CardContent>
                  </CardContent>
                  <CardActions classes={{root: classes.cardAction}}>
                    <Button
                      size="small"
                      component={Link}
                      to="barcode-library"
                      value="barcode-library"
                      onClick={pageClick}
                      classes={{
                        root: [classes.libraryBG, classes.btnText].join(' '),
                      }}
                    >
                      {t('barcode.landing-page.go-to-library')}
                    </Button>
                  </CardActions>
                  <CardActions classes={{root: classes.cardAction}}>
                    <Mutation mutation={userUpdate}>
                      {userUpdate => (
                        <Radio
                          checked={selectedValue === 'library'}
                          onChange={e => handleChange(userUpdate, e)}
                          color="primary"
                          value="library"
                        />
                      )}
                    </Mutation>
                    <Typography variant="body2" color="textSecondary">
                      {t('barcode.landing-page.set-library')}
                    </Typography>
                  </CardActions>
                </Card>
              </Paper>
            </Grid>

            <Grid item xs={5}>
              <Paper>
                <Card>
                  <CardContent classes={{root: classes.cardAction}}>
                    <img
                      src={WizardImage}
                      className={[classes.image, classes.wizardBG].join(' ')}
                      alt="Wizard Display"
                    />
                    <CardContent>
                      <Typography
                        gutterBottom
                        variant="h5"
                        component="h2"
                        color="primary"
                        style={{fontWeight: 'bold'}}
                      >
                        {t('barcode.landing-page.barcode-wizard')}
                      </Typography>
                      <Typography variant="body2" component="p" style={{fontWeight: 'bold'}}>
                        {t('barcode.landing-page.create-barcode')}
                      </Typography>
                    </CardContent>
                  </CardContent>
                  <CardActions classes={{root: classes.cardAction}}>
                    <Button
                      size="small"
                      variant="contained"
                      component={Link}
                      to="barcode-wizard"
                      onClick={pageClick}
                      classes={{
                        root: [classes.wizardBG, classes.btnText].join(' '),
                      }}
                    >
                      {t('barcode.landing-page.barcode-wizard')}
                    </Button>
                  </CardActions>
                  <CardActions classes={{root: classes.cardAction}}>
                    <Mutation mutation={userUpdate}>
                      {userUpdate => (
                        <Radio
                          checked={selectedValue === 'wizard'}
                          onChange={e => handleChange(userUpdate, e)}
                          color="primary"
                          value="wizard"
                        />
                      )}
                    </Mutation>
                    <Typography variant="body2" color="textSecondary">
                      {t('barcode.landing-page.set-wizard')}
                    </Typography>
                  </CardActions>
                </Card>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Container>
      <div className="welcome-text">
        <Typography variant="body2" style={{fontWeight: 'bold'}}>
          {t('barcode.landing-page.change-anytime')}
        </Typography>
      </div>
    </div>
  )
}
